import React from "react";
import { Modal, Button } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import "./DeleteConfirmationModal.css";

const DeleteConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  loading = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-confirmation-modal"
    >
      <Modal.Header className="delete-modal-header">
        <div className="delete-modal-title-section">
          <Modal.Title className="delete-modal-title">Delete Job?</Modal.Title>
          <div className="delete-modal-header-icons">
            <Button variant="link" onClick={onHide} className="close-button">
              <X size={30} />
            </Button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="delete-modal-body">
        <ul className="delete-warning-list">
          <li>
            This will permanently delete all job data — including the job
            booking, job setup, inspection record and any compiled report.
          </li>
          <li>This action cannot be reversed.</li>
        </ul>
      </Modal.Body>

      <Modal.Footer className="delete-modal-footer">
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
